// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divider_fPvhz {
  width: 100%;
  height: 0px;
  border: 1px solid var( --color-base200 );
}

.container_B1iZb {
  background: #FFFFFF;
  border: 1px solid var( --color-base100 );
  border-radius: 8px;
  padding: 12px;
}

.icon_b_Sqd {
  width: 20px;
  height: 20px;
}

.name_RI182 {
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 15px !important;
  line-height: 24px !important;
  color: var( --color-base700 ) !important;
}

.value_VTC9x {
  font-style: normal !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  line-height: 24px !important;
  color: var( --color-base800 ) !important;
}

.warningText_KPux0{
  white-space: pre-wrap;
}


.pill_zclPc {
  height: 24px;
  padding: 0;
  gap: 2px;
}

.pillRow_A5QaC{
  margin-bottom: 12px;
  gap: 12px;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/salesFlow/screens/BulkSaleInformation.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,YAAY;EACZ,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".divider {\n  width: 100%;\n  height: 0px;\n  border: 1px solid var( --color-base200 );\n}\n\n.container {\n  background: #FFFFFF;\n  border: 1px solid var( --color-base100 );\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.icon {\n  width: 20px;\n  height: 20px;\n}\n\n.name {\n  font-style: normal !important;\n  font-weight: 400 !important;\n  font-size: 15px !important;\n  line-height: 24px !important;\n  color: var( --color-base700 ) !important;\n}\n\n.value {\n  font-style: normal !important;\n  font-weight: 600 !important;\n  font-size: 15px !important;\n  line-height: 24px !important;\n  color: var( --color-base800 ) !important;\n}\n\n.warningText{\n  white-space: pre-wrap;\n}\n\n\n.pill {\n  height: 24px;\n  padding: 0;\n  gap: 2px;\n}\n\n.pillRow{\n  margin-bottom: 12px;\n  gap: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": `divider_fPvhz`,
	"container": `container_B1iZb`,
	"icon": `icon_b_Sqd`,
	"name": `name_RI182`,
	"value": `value_VTC9x`,
	"warningText": `warningText_KPux0`,
	"pill": `pill_zclPc`,
	"pillRow": `pillRow_A5QaC`
};
export default ___CSS_LOADER_EXPORT___;
